export const SURVEY_TEXT = 'Provide feedback about this Learning Experience.'
export const LAUNCH_ACTIVITY_BUTTON_TEXT = 'Launch Activity'
export const LAUNCH_LESSON_BUTTON_TEXT = 'Launch Lesson'
export const TEACH_BUTTON_TEXT = 'Teach'
export const RESUME_BUTTON_TEXT = 'Resume'
export const REVIEW_BUTTON_TEXT = 'Review'
export const PREVIEW_BUTTON_TEXT = 'Preview'

export const ATTEMPT_STATUS_BUTTON_TEXT = {
  'not attempted': TEACH_BUTTON_TEXT,
  incomplete: RESUME_BUTTON_TEXT,
  completed: REVIEW_BUTTON_TEXT,
}
